import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbDate, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { MatTabChangeEvent } from '@angular/material/tabs';

// services
import { OrdersService } from '../services/orders.service';

// interface
import { OrderDetails } from '../interfaces/order-details'

@Component({
selector: 'app-delivery-estimate',
templateUrl: './delivery-estimate.component.html',
styleUrls: ['./delivery-estimate.component.scss']
})
export class DeliveryEstimateComponent implements OnInit {

	@Output() updateEstimateDate: EventEmitter<{status: string, message:string}> = new EventEmitter();

	@Input() public order;
	@Input() public network;
	@BlockUI() blockUI: NgBlockUI;
    dateRange: any = {};
	orderDetails: OrderDetails;
	displayFooterBtn: boolean = false;
    selectedTabIndex: string = "";

	hoveredDate: NgbDate | null = null;
	fromDate: NgbDate;
	toDate: NgbDate | null = null;
	fromDateFormated: Date;
	toDateFormated: Date | null = null;

	constructor(
		public activeModal: NgbActiveModal,
		private ordersService: OrdersService,
		private toastrService: ToastrService,
		public calendar: NgbCalendar,
	) {
		// affichage, initialisation des dates, selection de la date du jour
		this.fromDate = calendar.getToday();
		this.toDate = calendar.getNext(calendar.getToday(), 'd', 0);
	}

	ngOnInit(): void {
		this.getOrder();
	}


    onTabChange(event: MatTabChangeEvent): void {
				event.index == 0 ? this.selectedTabIndex = 'expedition' : this.selectedTabIndex = 'livraison';
        if (this.orderDetails.estimateStart === undefined || this.orderDetails.estimateEnd === undefined) {
            return
        }
        this.fromDate = null;
        this.toDate = null;
        if(this.selectedTabIndex == 'livraison'){
            this.fromDate = NgbDate.from({year: new Date(this.orderDetails.estimateStart).getUTCFullYear(), month: new Date(this.orderDetails.estimateStart).getUTCMonth() + 1, day: new Date(this.orderDetails.estimateStart).getUTCDate()});
			this.toDate = NgbDate.from({year: new Date(this.orderDetails.estimateEnd).getUTCFullYear(), month: new Date(this.orderDetails.estimateEnd).getUTCMonth() + 1, day: new Date(this.orderDetails.estimateEnd).getUTCDate()});
        }else{
            this.fromDate = NgbDate.from({year: new Date(this.orderDetails.estimateStartSend).getUTCFullYear(), month: new Date(this.orderDetails.estimateStartSend).getUTCMonth() + 1, day: new Date(this.orderDetails.estimateStartSend).getUTCDate()});
		    this.toDate = NgbDate.from({year: new Date(this.orderDetails.estimateEndSend).getUTCFullYear(), month: new Date(this.orderDetails.estimateEndSend).getUTCMonth() + 1, day: new Date(this.orderDetails.estimateEndSend).getUTCDate()});
        }
    }

	// désactive les jours passés
	public isDisabled(date: NgbDate) {
		const curentDate = new Date(date.year, date.month - 1, date.day);
		const todayDate = new Date();

		return curentDate < todayDate;
	}

	// selection des dates et affiche les btn annuler / valider
	public onDateSelection(date: NgbDate) {

		if (!this.fromDate && !this.toDate) {
			this.fromDate = date;
			this.fromDateFormated = new Date(Date.UTC(date.year, date.month - 1, date.day));
		} else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
			this.toDate = date;
			this.toDateFormated = new Date(Date.UTC(date.year, date.month - 1, date.day));
			this.displayFooterBtn = true
		} else {
			this.displayFooterBtn = false
			this.toDate = null;
			this.fromDate = date;
			this.toDateFormated = null;
			this.fromDateFormated = new Date(Date.UTC(date.year, date.month - 1, date.day));
		}
	}

	public isHovered(date: NgbDate) {
		return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
	}

	public isInside(date: NgbDate) {
		return date.after(this.fromDate) && date.before(this.toDate);
	}

	public isRange(date: NgbDate) {
		return date.equals(this.fromDate) || date.equals(this.toDate) || this.isInside(date) || this.isHovered(date);
	}

	public cancelDates() {
		this.activeModal.close();
		this.toastrService.warning('Les modifications n\'ont pas été enregistrées');
	}

	// Api, envoie des dates
	public validateDates(type: string) {
		this.blockUI.start('Loading');
		this.setupEstimationDates();
		this.blockUI.stop();
		this.updateEstimateDate.emit({
			status: 'success',
			message: `Les estimations ${type == 'expedition' ? "de temps d'expédition" : "de livraison" } pour la commande n°${this.orderDetails.id} ont bien été enregistrées`
		});
		this.activeModal.close();
	}

	// initialisation de l'affichage des dates
	private initEstimateDates() {

		// si il n'y a pas encore d'estimation on laisse la date du jour selectionné fait à partir du constructeur
		if (this.orderDetails.estimateStart === undefined || this.orderDetails.estimateEnd === undefined) {
			return
		}

		let estimateStart: Date = new Date(this.orderDetails.estimateStart);
		let estimateEnd: Date = new Date(this.orderDetails.estimateEnd);

		this.fromDate = NgbDate.from({year: estimateStart.getUTCFullYear(), month: estimateStart.getUTCMonth() + 1, day: estimateStart.getUTCDate()});
		this.toDate = NgbDate.from({year: estimateEnd.getUTCFullYear(), month: estimateEnd.getUTCMonth() + 1, day: estimateEnd.getUTCDate()});
	}

	// Request
	private getOrder(): void {

		this.blockUI.start('Loading');
		this.ordersService.getOrderDetails(this.order.id, this.network).subscribe(
			(res) => {
				if (res.success) {
					this.orderDetails = res.data;
                    this.selectedTabIndex = this.orderDetails?.status == "shipped" ? "livraison" : "expedition";
					this.initEstimateDates();
					this.blockUI.stop();
				} else {
					this.blockUI.stop();

					if (res.errorSet.includes('INVALID_PARAMS')) {
						this.toastrService.error('Les paramètres sont invalides');
					} else if (res.errorSet.includes('ERROR_SERVER')) {
						this.toastrService.error('Une erreur serveur est survenue');
					} else {
						this.toastrService.error('Une erreur s\'est produite');
					}
				}
			},
			(error) => {
				this.blockUI.stop();
				// console.error(error);
				this.toastrService.error('Une erreur s\'est produite');
			}
		);
	}

	private setupEstimationDates(): void {
		this.blockUI.start('Loading');
		this.ordersService.setupEstimationDates(
			this.order.id, this.network, this.fromDateFormated, this.toDateFormated, this.selectedTabIndex
		).subscribe(
			(res) => {
				if (res.success) {
					this.orderDetails = res.data;
					this.blockUI.stop();
				} else {
					this.blockUI.stop();

					if (res.errorSet.includes('INVALID_PARAMS')) {
						this.toastrService.error('Les paramètres sont invalides');
					} else if (res.errorSet.includes('ERROR_SERVER')) {
						this.toastrService.error('Une erreur serveur est survenue');
					} else {
						this.toastrService.error('Une erreur s\'est produite');
					}
				}
			},
			(error) => {
				this.blockUI.stop();
				// console.error(error);
				this.toastrService.error('Une erreur s\'est produite');
			}
		);
	}
}
